export enum ClientQuestionnaireKeynameEnum {
  QuebecTaxForm2023 = 'QUEBEC_TAX_FORM_2023',
  QuebecTaxForm2022 = 'QUEBEC_TAX_FORM_2022',
  QuebecTaxForm2021 = 'QUEBEC_TAX_FORM_2021',
  SalaryDividend = 'SALARY_DIVIDEND',
}
